//const uuid = require('uuid');
import ReactDOM from 'react-dom';
import React from 'react';
import PropTypes from 'prop-types';
const Moment = require('moment');
const uuid = require('uuid');

const _ = {
    map: require('lodash/map'),
    find: require('lodash/find'),
    findIndex: require('lodash/findIndex'),
    filter: require('lodash/filter'),
    forEach: require('lodash/forEach'),
    sortBy: require('lodash/sortBy'),
    isEqual: require('lodash/isEqual'),
    isEmpty: require('lodash/isEmpty'),
};

const Globals =              require('../../../../../app/globals');
const Strings =              require('../../../../../app/shared/Strings');
const ShortCourseUtil =      require('../../../../../app/shared/ShortCourseUtil');
const ShortCourseConstants = require('../../../../../app/shared/ShortCourseConstants');

const ReactMzlUtils = require('../../../util/ReactMzlUtils');

import LoadingMainContent from '../../loading/LoadingMainContent';

import ShortCoursePlayStore from '../../../stores/ShortCoursePlayStore';
import ShortCourseInstanceStore from '../../../stores/ShortCourseInstanceStore';
const VoiceStore = require('../../../stores/VoiceStore');
const VoiceActions = require('../../../actions/VoiceActions');
const ChatbotSystem = require('../../../util/ChatbotSystem');

import ShortCourseTopNav from './ShortCourseTopNav';
import ShortCourseSkillPanel from './ShortCourseSkillPanel';
import ShortCourseProgressMap from './ShortCourseProgressMap'; // FIXME: remove
import ShortCourseNode from './ShortCourseNode'; // FIXME: remove
import ChatBotActivity from './ChatBotActivity';

import CoachScriptElements from './CoachScriptElements';
import StudentReportTableShortCourse from '../../ShortCourseInstance/StudentReportTableShortCourse';
import AlwaysScrollToBottom from '../../common/AlwaysScrollToBottom';
import { isSmallMobile } from '../../../util/ResponsiveUtils';

const AvatarSelect = require('./AvatarSelect');

import IFrame from '../../IFrame';

const FLOW_FOCI = ShortCoursePlayStore.FLOW_FOCI;

const propTypes = {
    playStore: PropTypes.object.isRequired,
    askToExitCourse: PropTypes.func,
    onStudentFeedback: PropTypes.func, // call to open a dialog for a student to send course feedback

    // specified if we're on the actual play page
    playUrl: PropTypes.string, 
    playingActivity: PropTypes.bool,
    iframe: PropTypes.object,
    onClose: PropTypes.func,
    closeDisabled: PropTypes.bool,
};

const defaultProps = {
    playingActivity: false,
};

// This component is shown when playing a course 
class ShortCoursePlay extends React.Component {
    constructor(props) {
        super(props);
        const doc = this.props.playStore.getDoc();
        this.app = ReactMzlUtils.getAppForSharedComponents({ course_hash: doc.hash, getDoc: this.props.playStore.getDoc}); // for RichText from react-mzl
        this.iframe = props.iframe || React.createRef();
        let storeState = this.getStoreState(props);
        let userVoiceOptionsActionId = null;
        const userData = {
            permissions: this.props.playStore.getFeaturePermissions(),
            channelId: this.props.playStore.getChannelId(),
            shortCourseId: this.props.playStore.getShortCourseId(),
        };
        this.voiceSystem = VoiceStore.getVoiceSystem(VoiceStore.SYSTEM_USAGE.SHORT_COURSE_PLAY,{userData});
        this.chatbotSystem = new ChatbotSystem({userData, usage: ChatbotSystem.SYSTEM_USAGE.SHORT_COURSE_PLAY});
        
        const client_state = doc.user.client_state;
        if (client_state && client_state.voiceOptions) {
            userVoiceOptionsActionId = uuid.v4();
            // update voice options with saved state
            console.log("ShortCoursePlay updating voice options from userOptions:",JSON.stringify(userOptions)); // FIXME: remove debug spam
            const userOptions = client_state.voiceOptions;
            const storeOptions = this.getVoiceOptionsForPersistentState();
            if ((userOptions.disabled !== storeOptions.disabled) || (userOptions.volume !== storeOptions.volume)) {
                VoiceActions.setVoiceOptions(userVoiceOptionsActionId,{disabled:userOptions.disabled, volume:userOptions.volume});
            }
            if (userOptions.paused != storeOptions.paused) {
                VoiceActions.setVoiceElementPlay(userVoiceOptionsActionId,!userOptions.paused);
            }
        }
        else {
            console.log("ShortCoursePlay did not have any user voice options"); // FIXME: remove debug spam
        }

        this.state = {...storeState, 
            reviewingProgress: false, 
            transitioning: ShortCourseInstanceStore.getIsTransitioning(),
            userVoiceOptionsActionId,
        };
        this.unsubscribes = [
            this.props.playStore.getStore().listen(this.onPlayChange),
            ShortCourseInstanceStore.listen(this.onInstanceStoreChange),
            VoiceStore.listen(this.onVoiceStoreChange),
        ];
    }
    
    componentDidMount() {
        window.addEventListener('resize', this.onResize); // updateStickerPosition
        // this.updateStickerPosition();
        $(window).on('message',this.handleMessage);
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize); // updateStickerPosition
        this.unsubscribes.forEach(u => u());
        delete this.unsubscribes;
        $(window).off('message',this.handleMessage);
        if (this.voiceSystem) {
            this.voiceSystem.shutDown();
        }
        if (this.chatbotSystem) {
            this.chatbotSystem.shutDown();
        }
    }
    
    modifyLeftExpanded=(leftExpanded,smallScreen)=>{
        switch(this.state.flowFocus) {
            case FLOW_FOCI.WelcomeScreen:
            case FLOW_FOCI.FlowMap:
            case FLOW_FOCI.SingleNode:
            case FLOW_FOCI.AttemptCompleted:
                leftExpanded = true;
                break;
            case FLOW_FOCI.ActivityAttempt:
            case FLOW_FOCI.ChatBotAttempt:
            case FLOW_FOCI.ContentBlockLink:
            case FLOW_FOCI.CourseCompleted:
                leftExpanded = false;
                break;
            case FLOW_FOCI.AvatarSelectScreen:
                leftExpanded = smallScreen ? false : true;
                break;
        }
        return leftExpanded;
    }
    
    onResize=()=>{
        var smallScreen = isSmallMobile();
        if (smallScreen !== this.state.smallScreen) {
            var leftExpanded = this.modifyLeftExpanded(this.state.leftExpanded,smallScreen);
            this.setState({leftExpanded,smallScreen});
        }
    }
    
    getVoiceOptionsForPersistentState=()=>{
        let voiceStoreState = VoiceStore.getState();
        let {disabled,volume} = voiceStoreState.options;
        let paused = !!voiceStoreState.voiceElement.paused;
        return { disabled, volume, paused };
    }
    
    onVoiceStoreChange=(storeState)=>{
        if (storeState.action.id !== this.state.userVoiceOptionsActionId) {
            switch(storeState.action.type) {
                case 'setVoiceOptions':
                case 'setVoiceElementPlay':
                    break; // fall thru and update user state to match
                default:
                    return;
            }
            const voiceOptions = this.getVoiceOptionsForPersistentState();
            const doc = this.props.playStore.getDoc();
            const client_state = doc.user.client_state || {};
            if (!_.isEqual(client_state.voiceOptions, voiceOptions)) {
                console.log("ShortCoursePlay updating user options from voiceOptions:",JSON.stringify(voiceOptions)); // FIXME: remove debug spam
                this.props.playStore.updatePersistentVoiceOptions(voiceOptions)
            }
        }
    }
    
    handleMessage=(e)=>{
        var msg = e.originalEvent.data;
        var origin = e.originalEvent.origin;
        if (!GlobalConfig.DevMode && origin.indexOf('muzzylane.com') === -1) {
            return;
        }
        if (msg && msg.type) {
            const targetWindow = this.iframe && this.iframe.current && this.iframe.current.contentWindow;
            if (this.chatbotSystem) {
                let handled = this.chatbotSystem.handleMessage(msg,targetWindow);
                if (handled) {
                    return;
                }
            }
            if (this.voiceSystem) {
                let handled = this.voiceSystem.handleMessage(msg,targetWindow);
                if (handled) {
                    return;
                }
            }
            // other message handling here...
        }
    }

//    onScroll=()=>{
//        this.updateStickerPosition();
//    }

//    updateStickerPosition=()=>{
//        var domNode = $("#coach-sticker")[0];
//        if (domNode) {
//            let elem = $(".coach-lower-sticker-shape")[0]; // non-react element
//            if (elem) {
//                let relativeTo = $(".coach-conversation")[0].getBoundingClientRect();
//                let stickerBr = domNode.getBoundingClientRect();
//                let br = elem.getBoundingClientRect();
//                let scrollElem = $(".scroll-content.coach-size");
//                let scrollTop = scrollElem.scrollTop() || 0;
//                let stickerOffsetLeft = Math.round(br.left - relativeTo.left);
//                let stickerOffsetTop = Math.round(br.top - relativeTo.top - scrollTop - (stickerBr.height - br.height));
//                this.setState({
//                    stickerOffsetLeft: stickerOffsetLeft,
//                    stickerOffsetTop: stickerOffsetTop,
//                });
//            }
//        }
//    }

    exitRichTextScreen=()=>{
        this.props.playStore.actions.updatePersistentFlags();
        if (this.props.playStore.canAdvanceReportCard()) {
            return this.props.playStore.actions.advanceReportCard((phase)=>{
                // if this component is not going away, go on to the next step after finishing the report card (redmine #6209)
                if (this.unsubscribes && (phase === ShortCoursePlayStore.REPORT_CARD_PHASE.END)) {
                    if (this.props.playStore.canAdvanceCoachScript()) {
                        return this.props.playStore.actions.advanceCoachScript();
                    }
                }
            });
        }
        else if (this.props.playStore.canAdvanceCoachScript()) {
            return this.props.playStore.actions.advanceCoachScript();
        }
        
        switch(this.state.flowFocus) {
            case FLOW_FOCI.WelcomeScreen:
            case FLOW_FOCI.AttemptCompleted:
                return this.props.playStore.actions.goToRecommendedNode();
            case FLOW_FOCI.CourseCompleted:
                return this.props.askToExitCourse ? this.props.askToExitCourse() : null;
        }
    }
    
//    returnToWelcomeScreen=()=>{
//        this.props.playStore.actions.setFlowFocus({flowFocus: FLOW_FOCI.WelcomeScreen});
//    }
    
//    returnToFlowMap=()=>{
//        this.props.playStore.actions.setFlowFocus({flowFocus: FLOW_FOCI.FlowMap});
//    }

//    returnToNode=()=>{
//        this.props.playStore.actions.setFlowFocus({flowFocus: FLOW_FOCI.SingleNode});
//    }

    getStoreState=(props)=>{
        let playStoreState = props.playStore.getStore().getState();
        if (_.isEmpty(playStoreState)) {
            // store has not been initialized yet
            return {
                flowFocus: null,
                node_id: undefined,
                leftExpanded: false,
            };
        }
        let flowFocus = playStoreState.flowFocus;
        let node_id = playStoreState.node_id;
        props.playStore.gatherCoachDataForNode(node_id);
        let leftExpanded = false;
        let smallScreen = isSmallMobile();
        const cb = props.playStore.getCurrentContentBlock();
        if (props.playingActivity) {
            if (cb.type === Globals.short_course.content_block_type.CHATBOT) {
                flowFocus = FLOW_FOCI.ChatBotAttempt;
            }
            else {
                flowFocus = FLOW_FOCI.ActivityAttempt;
            }
        }
        else if (this.state) {
            leftExpanded = this.modifyLeftExpanded(this.state.leftExpanded, smallScreen);
        }
        return { flowFocus, node_id, leftExpanded, smallScreen }
    }
    
    onPlayChange=(storeState)=>{
        this.setState(this.getStoreState(this.props));
//        ,()=>{
//            this.updateStickerPosition();
//            setTimeout(this.updateStickerPosition,1);
//        });
    }
    
    onInstanceStoreChange=(storeState)=>{
        let transitioning = ShortCourseInstanceStore.getIsTransitioning();
        this.setState({transitioning});
    }
    
    toggleLeftExpand=()=>{
        this.setState({leftExpanded: !this.state.leftExpanded});
    }

    onAvatarSelect=(name,hash)=>{
        let avatar = {name,hash};
        if (this.props.playStore.getIsPreview()) {
            this.props.playStore.actions.setAvatar(avatar);
            return this.props.playStore.actions.exitAvatarSelect();
        }
        
        const doc = this.props.playStore.getDoc();
        const uuid = require('uuid');
        const AccountActions = require('../../../actions/AccountActions');
        AccountActions.updateAvatar(uuid.v4(), {
            userId: doc.user.id,
            avatar_name:name,
            avatar_hash:hash,
            callback: ()=>{
                this.props.playStore.onUpdateAvatar({avatar_name:name,avatar_hash:hash});
                return this.props.playStore.actions.exitAvatarSelect();
            }
        });
        
// deprecated (now we set the avatar for the user globally)
//        const ShortCourseInstanceActions = require('../../../actions/ShortCourseInstanceActions');
//        const instanceHash = doc.hash;
//        ShortCourseInstanceActions.setShortCourseInstanceAvatar(uuid.v4(), {
//            instanceHash,
//            avatar,
//            successCallback: ()=>{
//                this.props.playStore.actions.setAvatar(avatar);
//                return this.props.playStore.actions.goToRecommendedNode();
//            }
//        });
    }
    
    toggleReviewProgress=()=>{
        let reviewingProgress = !this.state.reviewingProgress;
        let reviewData = null;
        if (reviewingProgress) {
            // calculate review data
            const doc = this.props.playStore.getDoc(); // shortCourseInstance if not preview
            const courseComplete = (this.state.flowFocus === FLOW_FOCI.CourseCompleted);
            let statusKey = courseComplete ? 'COMPLETE' : 'IN_PROGRESS';
            let status = {
                status: Globals.attempt.user_statuses[statusKey],
                displayName: Strings['en'].short_course_instance.user_status[statusKey]
            };
            const userId = doc.user.id;
            const student_aggregates = StudentReportTableShortCourse.calculateAggregates(doc);
            const agg = student_aggregates[userId];
            reviewData = {
                status, 
                timePlayed: agg ? agg.time_played : 0,
                startTime: agg ? Moment(agg.start_time).format('YYYY-MM-DD, h:mm:ss a') : '',
                completeTime: (courseComplete && agg) ? Moment(agg.last_time).format('YYYY-MM-DD, h:mm:ss a') : ''
            };
        }
        this.setState({reviewingProgress, reviewData});
    }
    
    renderCoachElements=()=>{
        return (
            <CoachScriptElements 
                app={this.app}
                playStore={this.props.playStore}
                includePriorCoachElements={ true }
                onAudioFinish={null/*this.exitRichTextScreen*/}
                />
        );
    }

    render() {
        const doc = this.props.playStore.getDoc(); // shortCourseInstance if not preview
        //console.log("ShortCoursePlay doc:",doc);
        const avatar = this.props.playStore.getAvatar();
        let mainContent = null;
        let flowFocus = this.state.flowFocus; // show loading spinner if we're still waiting for meta data
        if (!this.props.playingActivity) {
            if (this.state.transitioning || this.props.loading) {
                flowFocus = null; // wait for data hocs to settle before showing anything
            }
        }

        let leftWidth,rightWidth,toolbarWidth,channelWidth,skillPanelLeft;
        let leftToggleClassName,leftToggleAriaLabel,skillPanel;
        let activityNameWidth = '64rem'; // column of student review panel
        toolbarWidth = '6rem';
        channelWidth = '1rem';
        skillPanelLeft = '7rem'; // toolbarWidth + channelWidth
        if (this.state.leftExpanded) {
            leftWidth = '40rem';
            activityNameWidth = '24rem';
            rightWidth = 'calc(100% - 40rem)';
            leftToggleClassName = "fa fa-arrow-left";
            leftToggleAriaLabel = "Collapse Skill Panel";
            skillPanel = ( <ShortCourseSkillPanel playStore={this.props.playStore} top={channelWidth} left={skillPanelLeft} /> );
        }
        else {
            leftWidth = toolbarWidth;
            rightWidth = 'calc(100% - ' + toolbarWidth + ')';
            leftToggleClassName = "fa fa-arrow-right";
            leftToggleAriaLabel = "Expand Skill Panel";
        }

        let canAdvanceCoachScript = this.props.playStore.canAdvanceCoachScript();
        let coachElements;
        let playingActivity = false;
        if (this.state.reviewingProgress) {
            mainContent = (
                <div className="short-course-review-progress">
                    <StudentReportTableShortCourse
                        doc={doc}
                        students={doc.students}
                        getStatusForStudent={()=>(this.state.reviewData.status)}
                        getTimePlayedForStudent={()=>(this.state.reviewData.timePlayed)}
                        getStartTimeForStudent={()=>(this.state.reviewData.startTime)}
                        getCompleteTimeForStudent={()=>(this.state.reviewData.completeTime)}
                        resetStudentAttempts={null}
                        studentViewer={doc.user.id}
                        mastery_score={doc.mastery_score || 75}
                        activityNameWidth={activityNameWidth}
                    />
                </div>
            )
        }
        else switch(flowFocus) {
            case FLOW_FOCI.ErrorScreen:
                mainContent = ( 
                    <div className="short-course-error-screen">
                        <h1>{this.props.playStore.getErrorTitle()}</h1>
                        <div>{this.props.playStore.getErrorText()}</div>
                        {this.props.askToExitCourse ? 
                        <button className="btn bt-primary" onClick={this.props.askToExitCourse}>Close</button>
                        : null }
                    </div>
                );
                break;
            case FLOW_FOCI.FlowMap:
                mainContent = ( 
                    <ShortCourseProgressMap playStore={this.props.playStore}/>
                );
                break;
            case FLOW_FOCI.WelcomeScreen:
            case FLOW_FOCI.SingleNode:
                mainContent = ( 
                    <ShortCourseNode node_id={this.state.node_id} playStore={this.props.playStore} instanceHash={doc.hash} channelWidth={channelWidth} />
                );
                break;
                
            case FLOW_FOCI.ActivityAttempt:
            case FLOW_FOCI.ContentBlockLink:
                playingActivity = true;
                if (this.props.playUrl || this.props.playStore.getIsPreview()) {
                    const playUrl = this.props.playUrl || this.props.playStore.getCurrentContentBlockUrl();
                    mainContent = (
                        <div className="short-course-preview-content">
                            <IFrame ref={this.iframe} url={playUrl}/>
                        </div>
                    );
                } // else iframe is shown along a different react route
                break;
            case FLOW_FOCI.ChatBotAttempt:
                playingActivity = true;
                mainContent = (
                    <div className="short-course-preview-content">
                        <ChatBotActivity playStore={this.props.playStore}/>
                    </div>
                );
                break;
                
            case FLOW_FOCI.AttemptCompleted:
            case FLOW_FOCI.CourseCompleted:
            {
                coachElements = this.renderCoachElements();
                mainContent = (
                    <div className="short-course-coach-screen" style={{top: channelWidth}}>
                        <div className="scroll-area">
                            <div className="coach-area">
                                <div className="scroll-content coach-size" onScroll={ this.onScroll }>
                                    { this.renderCoachElements() }
                                    <div className="bottom-button-area">
                                        <div className="rel-centered-h">
                                            <button className="btn btn-primary continue-button" onClick={()=>{ this.exitRichTextScreen() } }>
                                                {'Continue'}
                                            </button>
                                        </div>
                                    </div>
                                    <AlwaysScrollToBottom/>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                );
                break;
            }
            case FLOW_FOCI.AvatarSelectScreen:
                mainContent = (
                    <AvatarSelect setPlayerNameAndHash={this.onAvatarSelect} defaultPlayerName={avatar.name} defaultAvatarHash={avatar.hash} channelWidth={channelWidth} showVoiceOptions />
                )
                break;

            case null: // loading
                mainContent = ( <LoadingMainContent/> );
                break;
                
            default:
                console.log(`Unhandled playFocus ${this.state.playFocus}`);
                mainContent = ( <span>{`Course Preview: ${this.state.playFocus}`}</span> )
                break;
        
        } // switch

        let bgImgSrc = doc.client_content.background_img;
        if (bgImgSrc) {
            bgImgSrc = bgImgSrc.replace(/^\$ASSET_PREFIX/, GlobalConfig.AssetStoreUrl);
        }

        return (
            <div className="short-course-play">
                <ShortCourseTopNav playStore={this.props.playStore} 
                    askToExitCourse={this.props.askToExitCourse}
                    onStarClick={this.toggleLeftExpand}
                    onClose={this.props.onClose} 
                    onStudentFeedback={this.props.onStudentFeedback}
                    reviewingProgress={this.state.reviewingProgress}
                    playingActivity={playingActivity}
                    onReviewButton={this.toggleReviewProgress}
                    closeDisabled={this.props.closeDisabled}/>
                <div className="split-div">
                    {bgImgSrc ? <img className="course-bg" alt="" aria-hidden src={bgImgSrc} /> : null }
                    <div className="left-content" style={{width: leftWidth}}>
                        <div className="toolbar" style={{width: toolbarWidth}}>
                            <span className="toggle-button" role="button" aria-label={leftToggleAriaLabel} title={leftToggleAriaLabel} onClick={this.toggleLeftExpand}>
                                [
                                <i className={leftToggleClassName} aria-hidden="true" />
                            </span>
                        </div>
                        {skillPanel}
                    </div>
                    <div className={this.state.smallScreen ? "right-content mobile" : "right-content"} style={{width: rightWidth}}>
                        <div className="main-content">
                            {mainContent}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ShortCoursePlay.propTypes = propTypes;
ShortCoursePlay.defaultProps = defaultProps;

export default ShortCoursePlay;